import type { ValuesType } from '@fifa-bsm/bo-frontend-shared/utils/types';

export const UserEntityPermission = Object.freeze({
    FULL_ACCESS: 'full-access',
    LIMITED_ACCESS: 'limited-access',
});

export type IUserEntityPermission = ValuesType<typeof UserEntityPermission>;
